module.exports = __webpack_public_path__ + "img/select-lang-btn-de.c2f4b35e.png";